function isPresent(visualElement) {
  var _a;
  return (_a = visualElement.projection) == null ? void 0 : _a.isPresent;
}
export {
  isPresent
};
